import { Group, Image, Text } from "@mantine/core";

import { CHECK_ICON } from "constants/app";
import classes from "./index.module.css";

interface IIconValue {
  text: string;
}

const IconValue = ({ text }: IIconValue) => {
  return (
    <Group>
      <Image width="25" height="20" src={CHECK_ICON} alt="Check icon" />
      <Text className={classes.value}>{text}</Text>
    </Group>
  );
};

export default IconValue;
